import { render, staticRenderFns } from "./order_collection.vue?vue&type=template&id=7276717e"
import script from "./order_collection.vue?vue&type=script&lang=js"
export * from "./order_collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7276717e')) {
      api.createRecord('7276717e', component.options)
    } else {
      api.reload('7276717e', component.options)
    }
    module.hot.accept("./order_collection.vue?vue&type=template&id=7276717e", function () {
      api.rerender('7276717e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/dealer_related_information_report/visitDetail/components/order_collection.vue"
export default component.exports